import EventBus from "./event-bus.js"

const togglePlayKey = "Space"
const backwardFrameKey = "KeyA"
const forwardFrameKey = "KeyD"
const incrementPlaybackRateKey = "KeyW"
const decrementPlaybackRateKey = "KeyS"
const replayKey = "KeyR"
const confirmOrderKey = "KeyJ"
const alternateConfirmOrderKey = "KeyF"
const togglePlayFullKey = "KeyQ"

function monitorKeyEvent(e) {
    if (e.code == togglePlayKey) {
        // 禁止按空格时商品列表滚动和停止接单选项框响应。
        e.preventDefault();
        EventBus.$emit("playerToggle")
    } else if (e.code == backwardFrameKey) {
        EventBus.$emit("seekBackward", 0.03)
    } else if (e.code == forwardFrameKey) {
        EventBus.$emit("seekForward", 0.03)
    } else if (e.code == incrementPlaybackRateKey) {
        EventBus.$emit("incrementPlaybackRate")
    } else if (e.code == decrementPlaybackRateKey) {
        EventBus.$emit("decrementPlaybackRate")
    } else if (e.code == replayKey) {
        EventBus.$emit("replayVideo")
    } else if (e.code == confirmOrderKey) {
        // EventBus.$emit("fastConfirm")
    } else if (e.code == togglePlayFullKey) {
        EventBus.$emit("playerFullPlay")
    }
}

function mouseSeekVideo(e) {
    if (e.deltaY > 0) {
        EventBus.$emit("seekForward", 0.03)
    } else {
        EventBus.$emit("seekBackward", 0.03)
    }
}

function monitorInputEvent() {
    window.addEventListener("keydown", monitorKeyEvent)
}

export {
    monitorInputEvent,
    mouseSeekVideo
}
